const PURCHASE_CARD_FONT_VAR = "--purchase-card-font";

export const purchaseCardFont = `var(${PURCHASE_CARD_FONT_VAR}, "Helvetica Neue", Helvetica, Arial, sans-serif)`;

export const purchaseCardColors = {
  surface: "#FFFFFF",
  border: "#DEDEDE",
  ink: "#000000",
  inkMuted: "#2E2E2E",
  inkStrong: "#161616",
  pillNeutral: "#F2F2F2",
  accent: "#FF5718",
  accentSurface: "#FFF0EA",
  divider: "#C6C9D0",
  ctaSurface: "#000000",
  ctaInk: "#FFFFFF",
} as const;

export const purchaseCardText = {
  pretitle: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 500,
    letterSpacing: "0.02em",
    textTransform: "uppercase",
  },
  title: { fontSize: "18px", lineHeight: "27px", fontWeight: 500 },
  body: { fontSize: "14px", lineHeight: "21px", fontWeight: 400 },
  price: { fontSize: "28px", lineHeight: "38px", fontWeight: 500 },
  caption: { fontSize: "14px", lineHeight: "18px", fontWeight: 500 },
  feedback: { fontSize: "12px", lineHeight: "16px", fontWeight: 400 },
} as const;

export type PurchaseCardTextRole = keyof typeof purchaseCardText;
